import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { PointWithdrawal } from "@roman/shared/types/PointWithdrawal";
import { useEffect } from "react";
import useSWR from "swr";

type usePointWithdrawalsResponse = Omit<PointWithdrawal, "userId">[];

const fetcher = (url: string): Promise<usePointWithdrawalsResponse> => {
  const headers = authHeader.getOrThrow();
  return romanApi.get<usePointWithdrawalsResponse>(url, undefined, { headers });
};

export const usePointWithdrawals = (handleError: (err: RomanApiError) => void, isDemoMode: boolean) => {
  const demoData: usePointWithdrawalsResponse = [
    {
      id: "1",
      type: "Amazon",
      status: "Success",
      email: "demo@example.com",
      updatedAt: 1715769600,
      redeemablePoints: "10000",
    },
    {
      id: "2",
      type: "Google",
      status: "Success",
      email: "demo@example.com",
      updatedAt: 1715769600,
      redeemablePoints: "10000",
    },
  ];

  const {
    data: apiData,
    isLoading: isApiLoading,
    error: apiError,
  } = useSWR<usePointWithdrawalsResponse, RomanApiError>("/point-withdrawals", fetcher);
  const data = isDemoMode ? demoData : apiData;
  const isLoading = isDemoMode ? false : isApiLoading;
  const error = isDemoMode ? null : apiError || null;

  useEffect(() => {
    if (error && !isDemoMode) {
      handleError(error || apiError);
    }
  }, [error, apiError, handleError, isDemoMode]);

  return {
    data,
    isLoading,
  };
};
